import { render, staticRenderFns } from "./opted-out.vue?vue&type=template&id=40e68990&"
import script from "./opted-out.vue?vue&type=script&lang=js&"
export * from "./opted-out.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports